import Head from 'next/head';
import { stringifyUrl } from 'query-string';
import { useIntl } from 'react-intl';
import { useTenantContext } from '../../context/TenantContext';
import Formed from '../Formed';
import SearchBoxComponent, {
    getInitialSearchBoxValues,
    getSearchValidationSchema,
    SearchBarValues,
} from '../SearchBox';

// this is a page that the main website fetches to render our search component on there.

const SearchBox = () => {
    const intl = useIntl();
    const { brandConfig } = useTenantContext();
    const validationSchema = getSearchValidationSchema();

    return (
        <>
            <Head>
                {brandConfig.searchBox?.styleSheetUrl && (
                    <link rel="stylesheet" href={brandConfig.searchBox.styleSheetUrl} type="text/css" />
                )}
            </Head>
            <Formed<SearchBarValues>
                handleSubmit={({ accommodationType, booking }) => {
                    window.location.href = stringifyUrl({
                        url: `${process.env.NEXT_PUBLIC_BASE_URL ?? ''}/${intl.locale}/search`,
                        query: {
                            amountAdults: (booking.amountAdults ?? 2).toString(),
                            amountBabies: (booking.amountBabies ?? 0).toString(),
                            amountChildren: (booking.amountChildren ?? 0).toString(),
                            amountYouths: (booking.amountYouths ?? 0).toString(),
                            amountPets: (booking.amountPets ?? 0).toString(),
                            arrivalDate: (booking.arrivalDate ?? '').toString(),
                            departureDate: (booking.departureDate ?? '').toString(),
                            accommodationType,
                        },
                    });
                }}
                initialValues={getInitialSearchBoxValues(brandConfig)}
                validationSchema={validationSchema}
                skipPrompt
            >
                {({ isSubmitting }) => (
                    <SearchBoxComponent variant="home" isSubmitting={isSubmitting} hideCalendarIcon hideHelper />
                )}
            </Formed>
        </>
    );
};

export default SearchBox;
